<template>
    <div class="loading line1" :class="{visible: visible}"></div>
</template>

<script>
    export default {
        name: "Loading",
        props: {
            type: {
                type: String,
                default: 'line'
            },
            visible: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style scoped lang="scss">
    .loading {
        visibility: hidden;

        &.line1 {
            position: relative;
            height: 3px;
            overflow: hidden;

            &:before{
                display: block;
                position: absolute;
                content: "";
                left: -200px;
                width: 200px;
                height: 100%;
                background-color: #1ab39a;
                animation: loadingLine1 2s linear infinite;
            }

        }

        &.visible{visibility: visible}
    }

    @keyframes loadingLine1 {
        from {left: -200px; width: 30%;}
        50% {width: 30%;}
        70% {width: 70%;}
        80% { left: 50%;}
        95% {left: 120%;}
        to {left: 100%;}
    }
</style>
